import {
  SET_CENTROS_CUSTOS,
  SET_SOLICITANTES,
  SET_SEARCH_TEXT,
  SET_EMPRESA,
  SET_PRODUTO,
  SET_PROJETO,
  SET_GRUPO,
} from './mutations.type';

export default {
  [SET_CENTROS_CUSTOS](state, centrosCustos) {
    state.centrosCustos = centrosCustos;
  },
  [SET_SOLICITANTES](state, solicitantes) {
    state.solicitantes = solicitantes;
  },
  [SET_SEARCH_TEXT](state, searchText) {
    state.searchText = searchText;
  },
  [SET_EMPRESA](state, empresa) {
    state.empresa = empresa;
  },
  [SET_PRODUTO](state, produto) {
    state.produto = produto;
  },
  [SET_PROJETO](state, projeto) {
    state.projeto = projeto;
  },
  [SET_GRUPO](state, grupo) {
    state.grupo = grupo;
  },
};
